import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HeaderHelperService } from '../header-helper.service';

@Injectable({
  providedIn: 'root',
})
export class SpecialismsService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService 
  ) {}

  getSpecialisms(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiLocations.identity}/Specialisms`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}
